export default "__VITE_ASSET__rbiHftNe__"